import { TextField } from "@mui/material";
import React from "react";

interface CalendarInputProps {
  calendarId: string;
  onChange: (id: string) => void;
}

export const CalendarInput: React.FC<CalendarInputProps> = ({
  calendarId,
  onChange,
}) => {
  return (
    <TextField
      label="Kalender-ID"
      value={calendarId}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      fullWidth
    />
  );
};
